module.exports = __webpack_public_path__ + "img/logo1 (28).a3ceac01.jpg";